import React, { useEffect, useState, useMemo } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';
import { jwtDecode } from 'jwt-decode';

const StaffRequisitions = () => {
  // Add this useEffect to create lookup objects
  const [reviewersLoading, setReviewersLoading] = useState(true);
  const [reviewerById, setReviewerById] = useState({});
  const [reviewerByNumber, setReviewerByNumber] = useState({});
  const navigate = useNavigate();
  const location = useLocation(); 
  const [requisitions, setRequisitions] = useState([]);
  const theUserType = localStorage.getItem('userType');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 'All'); 
  const [loading, setLoading] = useState(false); 
  const storedFullName = localStorage.getItem('fullName');
  const [reviewers, setReviewers] = useState([]);
  const theUserId = localStorage.getItem('userId');
  const [reviewerNumber, setReviewerNumber] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Starting with 20 items
  const [searchTerm, setSearchTerm] = useState(''); 

// Add this function after your state declarations
  const getReviewerByNumber = (reviewerNumber) => {
      return reviewers.find(r => r.reviewerNumber === reviewerNumber);
   };


useEffect(() => {
  const fetchReviewers = async () => {
    try {
      setReviewersLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
      const data = response.data;
  
      console.log("Reviewers API response:", data);
      
      // Handle both formats: plain array or { $values: [...] }
      let reviewersArray = [];
      
      if (Array.isArray(data)) {
        // It's already an array
        reviewersArray = data;
      } else if (data && Array.isArray(data.$values)) {
        // It's wrapped in $values
        reviewersArray = data.$values;
      } else {
        console.error("Unexpected reviewers response format:", data);
        setReviewers([]);
        return;
      }
  
      const allReviewers = reviewersArray.map(r => ({
        ...r,
        id: String(r.id),
        reviewerNumber: r.reviewerNumber || null
      }));
      
      console.log("Processed reviewers:", allReviewers);
      setReviewers(allReviewers);
  
      if (!theUserId) return;
  
      const current = allReviewers.find(r => r.id === String(theUserId));
      if (!current) return;
  
      const currentNum = current.reviewerNumber;
      setReviewerNumber(currentNum);
  
    } catch (error) {
      console.error("Error fetching reviewers:", error);
      setReviewers([]);
    } finally {
      setReviewersLoading(false);
    }
  };
  
  fetchReviewers();
}, [theUserId]);


  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
  
    const decoded = jwtDecode(token); 
    setReviewerNumber(decoded.reviewerNumber || null); 
  }, []);
  
  useEffect(() => {
    fetchRequisitionsByStatus(activeTab);
  }, [activeTab]); 

  useEffect(() => {
  if (requisitions.length > 0) {
    console.log("=== REQUISITIONS DATA ===");
    console.log("First requisition:", requisitions[0]);
    console.log("All requisitions count:", requisitions.length);
    
    // Check for next reviewer fields
    requisitions.slice(0, 3).forEach((req, index) => {
      console.log(`Requisition ${index + 1}:`, {
        id: req.requisitionID,
        nextReviewerId: req.nextReviewerId,
        currentReviewerNumber: req.currentReviewerNumber,
        status: req.status
      });
    });
  }
}, [requisitions]);

useEffect(() => {
  console.log("=== REVIEWERS DATA ===");
  console.log("Reviewers loaded:", reviewers.length);
  reviewers.forEach(r => {
    console.log(`Reviewer: ${r.firstName} ${r.lastName}, ID: ${r.id}, Number: ${r.reviewerNumber}`);
  });
}, [reviewers]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSearchTerm(''); // Clear search when changing tabs - NEW
  };

// Update your useEffect that creates lookup objects
useEffect(() => {
  if (reviewers.length > 0) {
    console.log("=== CREATING REVIEWER LOOKUPS ===");
    console.log("Reviewers to process:", reviewers);
    
    // Create lookup by ID
    const byId = {};
    const byNumber = {};
    
    reviewers.forEach(reviewer => {
      if (reviewer.id) {
        byId[reviewer.id] = reviewer;
      }
      if (reviewer.reviewerNumber !== null && reviewer.reviewerNumber !== undefined) {
        byNumber[reviewer.reviewerNumber] = reviewer;
      }
    });
    
    console.log("Reviewer by ID lookup:", byId);
    console.log("Reviewer by Number lookup:", byNumber);
    
    setReviewerById(byId);
    setReviewerByNumber(byNumber);
    
    console.log("Lookup created. Keys in byNumber:", Object.keys(byNumber));
  }
}, [reviewers]);


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Filter requisitions based on search term - NEW FUNCTION
const filteredRequisitions = useMemo(() => {
  let result = requisitions;
  
  // Apply search filter
  if (searchTerm.trim()) {
    const searchLower = searchTerm.toLowerCase();
    result = result.filter(requisition => {
      // Search in Staff Name
      if (requisition.staffName && requisition.staffName.toLowerCase().includes(searchLower)) {
        return true;
      }
      
      // Search in Activity Start Date
      if (requisition.from) {
        const date = new Date(requisition.from);
        const formattedDate = `${date.getDate()} ${date.toLocaleString("en-US", { month: "long" })} ${date.getFullYear()}`;
        if (formattedDate.toLowerCase().includes(searchLower)) {
          return true;
        }
      }
      
      // Search in Activity Name
      if (requisition.activityName && requisition.activityName.toLowerCase().includes(searchLower)) {
        return true;
      }
      
      // Search in Activity Purpose
      if (requisition.activityPurpose && requisition.activityPurpose.toLowerCase().includes(searchLower)) {
        return true;
      }
      
      // Search in District and AP
      let districtPairs = [];
      if (requisition.districtAndAreaProgramPairs?.$values?.length > 0) {
        districtPairs = requisition.districtAndAreaProgramPairs.$values;
      } else if (Array.isArray(requisition.districtAndAreaProgramPairs) && requisition.districtAndAreaProgramPairs.length > 0) {
        districtPairs = requisition.districtAndAreaProgramPairs;
      } else if (requisition.districtAndAreaProgramPairsActuals?.length > 0) {
        districtPairs = requisition.districtAndAreaProgramPairsActuals;
      } else if (requisition.districtsAndPrograms?.length > 0) {
        districtPairs = requisition.districtsAndPrograms;
      }
      
      const hasDistrictMatch = districtPairs.some(pair => {
        const district = (pair.district || pair.districtName || '').toLowerCase();
        const areaProgram = (pair.areaProgram || pair.program || pair.areaProgramName || '').toLowerCase();
        return district.includes(searchLower) || areaProgram.includes(searchLower);
      });
      
      return hasDistrictMatch;
    });
  }
  
  // Sort once here (not in render)
  return [...result].sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate));
}, [requisitions, searchTerm]);

  const paginatedRequisitions = useMemo(() => {
    return filteredRequisitions.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }, [filteredRequisitions, currentPage, itemsPerPage]);


  // Memoized reviewer lookup functions
  const getReviewerById = useMemo(() => {
    return (reviewerId) => reviewers.find(r => String(r.id) === String(reviewerId));
  }, [reviewers]);

  const getReviewerByNumberMemo = useMemo(() => {
    return (reviewerNum) => reviewerByNumber[reviewerNum] || reviewers.find(r => r.reviewerNumber === reviewerNum);
  }, [reviewers, reviewerByNumber]);

  // Memoized function to get current reviewer name
  const getCurrentReviewerName = useMemo(() => {
    return (req) => {
      // 1. Check for surrender reviewer claim
      if (req.claimedBySurrenderReviewerId) {
        const surrenderReviewer = getReviewerById(req.claimedBySurrenderReviewerId);
        if (surrenderReviewer) {
          return `${surrenderReviewer.firstName} ${surrenderReviewer.lastName}`;
        }
      }

      // 2. Check based on currentReviewerNumber
      if (req.currentReviewerNumber !== undefined && req.currentReviewerNumber !== null) {
        const reviewerNum = req.currentReviewerNumber === 0 ? -1 : req.currentReviewerNumber;
        
        if (reviewerNum === -1) {
          return "Admin Team Member";
        } else if (reviewerNum >= 1 && reviewerNum <= 3) {
          const reviewer = getReviewerByNumberMemo(reviewerNum);
          if (reviewer) {
            return `${reviewer.firstName} ${reviewer.lastName}`;
          }
          return `Reviewer ${reviewerNum}`;
        }
      }

      // 3. Status-based defaults
      if (req.status === "Approved" || req.status === "To be disbursed") return "Final Approver";
      if (req.status === "Disbursed") return "Finance";
      if (req.status === "Draft") return "Requester (Draft)";
      if (req.status === "Submitted") return "Awaiting Reviewer 1";
      if (req.status === "Disapproved") return "Returned to Requester";
      
      return "Not assigned";
    };
  }, [getReviewerById, getReviewerByNumberMemo]);

  // Memoized function to get next reviewer name
  const getNextReviewerName = useMemo(() => {
    return (req) => {
      // 1. Check for surrender reviewer claim
      if (req.claimedBySurrenderReviewerId) {
        const surrenderReviewer = getReviewerById(req.claimedBySurrenderReviewerId);
        if (surrenderReviewer) {
          return `${surrenderReviewer.firstName} ${surrenderReviewer.lastName} (Surrender)`;
        }
      }

      // 2. Check direct nextReviewerId field
      if (req.nextReviewerId) {
        const reviewer = getReviewerById(req.nextReviewerId);
        if (reviewer) {
          return `${reviewer.firstName} ${reviewer.lastName}`;
        }
      }

      // 3. Check currentReviewerNumber to determine workflow
      if (req.currentReviewerNumber !== undefined && req.currentReviewerNumber !== null) {
        if (req.currentReviewerNumber === -1) {
          const reviewer1 = getReviewerByNumberMemo(1);
          return reviewer1 ? `${reviewer1.firstName} ${reviewer1.lastName}` : "Reviewer 1";
        } else if (req.currentReviewerNumber >= 1 && req.currentReviewerNumber < 3) {
          const nextNum = req.currentReviewerNumber + 1;
          const nextReviewer = getReviewerByNumberMemo(nextNum);
          return nextReviewer ? `${nextReviewer.firstName} ${nextReviewer.lastName}` : `Reviewer ${nextNum}`;
        } else if (req.currentReviewerNumber === 3) {
          return "Disbursement if Approved";
        }
      }

      // 4. Status-based defaults
      if (req.status === "Approved" || req.status === "To be disbursed") return "Disbursement if Approved";
      if (req.status === "Submitted") {
        const reviewer1 = getReviewerByNumberMemo(1);
        return reviewer1 ? `${reviewer1.firstName} ${reviewer1.lastName}` : "Reviewer 1";
      }
      if (req.status === "Draft") return "Not submitted";
      
      return "Not assigned";
    };
  }, [getReviewerById, getReviewerByNumberMemo]);

  const handleReview = (requisitionID) => {
    navigate(`/review-requisition/${requisitionID}`);
  };



  // Helper function to get district and area program pairs with proper styling
  const renderDistrictAndAreaPrograms = useMemo(() => {
    return (requisition) => {
      let pairs = [];
      
      if (requisition.districtAndAreaProgramPairs?.$values?.length > 0) {
        pairs = requisition.districtAndAreaProgramPairs.$values;
      } else if (Array.isArray(requisition.districtAndAreaProgramPairs) && requisition.districtAndAreaProgramPairs.length > 0) {
        pairs = requisition.districtAndAreaProgramPairs;
      } else if (requisition.districtAndAreaProgramPairsActuals?.length > 0) {
        pairs = requisition.districtAndAreaProgramPairsActuals;
      } else if (requisition.districtsAndPrograms?.length > 0) {
        pairs = requisition.districtsAndPrograms;
      }
      
      if (pairs.length === 0) {
        return <span className="text-muted">No District and Area Program Pairs. Try to refresh the page</span>;
      }

      return (
        <div>
          {pairs.map((pair, index) => (
            <div key={index}>
              <span className="badge bg-light text-dark border mb-1">
                {pair.district || pair.districtName} - {pair.areaProgram || pair.program || pair.areaProgramName}
              </span>
              <br />
            </div>
          ))}
        </div>
      );
    };
  }, []);
  
  const fetchRequisitionsByStatus = async (status) => {
    try {
      const token = localStorage.getItem("token");
      setError(null);
      setLoading(true); 
      
      let response;
      
      if (status === 'All') {
        response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (status === 'Reviewed') {
        response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
          params: { status, excludeUserId: theUserId },
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      let data = Array.isArray(response.data)
        ? response.data
        : response.data.$values ?? [];

      // Special handling for "Reviewed" tab
      if (status === 'Reviewed') {
        data = data.filter(requisition => 
          requisition.status && requisition.status.startsWith("Reviewed by")
        );
      }

      // Filter out current user's requisitions
      if (theUserId) {
        data = data.filter(requisition => 
          String(requisition.userId) !== String(theUserId)
        );
      }

      setRequisitions(data);
      setCurrentPage(1);
      
      if (data.length === 0) {
        if (status === 'Reviewed') {
          setError('No reviewed requisitions found.');
        } else if (status === 'All') {
          setError('No requisitions found.');
        } else {
          setError(`No requisitions found for status: ${status}.`);
        }
      } else {
        setError(null);
      }
      
    } catch (err) {
      console.error("Error fetching requisitions:", err);
      if (err.response?.status === 404) {
        setError(`No requisitions found.`);
      } else if (err.response?.status === 401) {
        setError("You must be logged in to view requisitions.");
      } else {
        setError("Error. Check Internet connection");
      }
      setRequisitions([]);
    } finally {
      setLoading(false); 
    }
  };


  const getStatusClass = (status) => {
    if (status === "Draft") return "status-draft"; 
    if (status === "Submitted") return "status-submitted";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    if (status === "Approved") return "status-approved";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status === "Disapproved") return "status-disapproved"; 
    if (status === "Disbursed") return "status-disbursed"; 
    if (status === "To be disbursed") return "status-to-be-disbursed"; 
    
    return ""; 
  };

  const PaginationControls = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    
    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} requisitions
          {searchTerm && <span className="text-muted ml-2">(filtered from {requisitions.length} total)</span>} 
        </div>
        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                Previous
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    );
  };

  return (
    <div id="wrapper">
      <Sidebar userType={theUserType} />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            {/* Sidebar Toggle*/}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Search */}
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
            
            {/* Header Row with Search Bar - NEW */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h1 className="h3 mb-0">Staff Requisitions</h1>
                <br/>
              </div>
              <div className="d-flex align-items-center">
                <div className="input-group" style={{ width: '300px' }}>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search" 
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <div className="input-group-append">
                    <button className="btn-outline-secondary round-right-corners" type="button">
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            

            {/* Tabs - Same as Requisitions component */}
            <div className="tabs">
              <button
                className={`nav-link ${activeTab === 'All' ? 'active' : ''}`}
                onClick={() => handleTabClick('All')}
              >
                All
              </button> 
              <button
                className={`nav-link ${activeTab === 'Submitted' ? 'active' : ''}`}
                onClick={() => handleTabClick('Submitted')}
              >
                Submitted
              </button>
              <button
                className={`nav-link ${activeTab === 'Reviewed' ? 'active' : ''}`}
                onClick={() => handleTabClick('Reviewed')} 
              >
                Reviewed 
              </button>
              <button
                className={`nav-link ${activeTab === 'Approved' ? 'active' : ''}`}
                onClick={() => handleTabClick('Approved')}
              >
                Approved
              </button>
              <button
                className={`nav-link ${activeTab === 'Disbursed' ? 'active' : ''}`}
                onClick={() => handleTabClick('Disbursed')}
              >
                Disbursed
              </button>
              <button
                className={`nav-link ${activeTab === 'Surrender Submitted' ? 'active' : ''}`}
                onClick={() => handleTabClick('Surrender Submitted')}
              >
                Surrender Submitted
              </button>
                        </div>

            {/* Loading Spinner */}
            {loading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-3 text-muted">Loading...</p>
              </div>
            )}

            {/* Requisitions Table - Only show when not loading */}
            {!loading && (
            <div id="requisition-table" className="table-responsive mt-4">
              <table className="table table-hover table-striped table-bordered text-sm align-middle">
                <thead className="thead-dark">
                  <tr>
                    <th className="text-nowrap">Staff Name</th>
                    <th className="text-nowrap">Activity Start Date</th>
                    <th className="text-nowrap">Activity Name</th>
                    <th className="text-nowrap">Activity Purpose</th>
                    <th className="text-nowrap">District and AP</th>
                    <th className="text-nowrap">Status</th>
                    <th className="text-nowrap">Current Reviewer</th>
                    <th className="text-nowrap">Next Reviewer</th>
                    {/* Only show Actions column if user is NOT Surrender Reviewer */}
                    {theUserType !== 'Surrender Reviewer' && (
                      <th className="text-nowrap">Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {!loading && !reviewersLoading && paginatedRequisitions.map((requisition) => {
                    const date = new Date(requisition.from);
                    const formattedDate = `${date.getDate()} ${date.toLocaleString("en-US", {
                      month: "long",
                    })} ${date.getFullYear()}`;

                    const currentReviewerName = getCurrentReviewerName(requisition);
                    const nextReviewerName = getNextReviewerName(requisition);

                      return (
                        <tr key={requisition.requisitionID}>
                          {/* Staff Name Column - similar to StaffSurrenders component */}
                          <td>{requisition.staffName}</td>
                          <td>{formattedDate}</td>
                          <td>{requisition.activityName}</td>
                          <td>{requisition.activityPurpose}</td>
                          <td>
                            {renderDistrictAndAreaPrograms(requisition)}
                          </td>
                          <td>
                            <div className={`badge ${getStatusClass(requisition.status)}`}>
                              {requisition.status}
                            </div>
                          </td>
                          <td>
                            <div className="current-reviewer-info">
                              <span >
                                {currentReviewerName}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className="next-reviewer-info">
                              <span>
                                {nextReviewerName}
                              </span>
                              { /*
                                requisition.nextReviewerId && (
                                  <small className="text-muted d-block">
                                    ID: {requisition.nextReviewerId}
                                  </small>
                                  
                                )*/
                               }
                            </div>
                          </td>
                          {/* Only show Actions cell if user is NOT Surrender Reviewer */}
                          {/*{theUserType !== 'Surrender Reviewer' && ( */}
                            <td>
                              <div className="d-flex gap-2 flex-wrap">
                                <Link to={`/review-requisition/${requisition.requisitionID}`}>
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => handleReview(requisition.requisitionID)}
                                  >
                                    <i className="fas fa-file-alt me-1"></i> Review
                                  </button>
                                </Link>
                              </div>
                            </td>
                          {/* })} */}
                        </tr>
                      ); 
                    })}
                 {filteredRequisitions.length === 0 && !error && (
                    <tr>
                      <td colSpan="9" className="text-center text-muted py-4"> {/* Changed from 7 to 9 */}
                        {searchTerm 
                          ? `"${searchTerm}" not found in the ${activeTab} tab`
                          : 'No requisitions found.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
                                                </div>
            )} {/* Close the !loading condition */}

            {/* ========== ADD PAGINATION CONTROLS HERE ========== */}
            {!loading && filteredRequisitions.length > itemsPerPage && (
              <PaginationControls
                totalItems={filteredRequisitions.length}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
              />
            )}
            {/* ================================================= */}

            {/* Error Message */}
            {error && (
              <div className="alert alert-warning mt-3" role="alert">
                {error}
              </div>
            )}
          </div>
          {/* End of container-fluid */}
        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};

export default StaffRequisitions;